import { jsx as o } from "react/jsx-runtime";
const t = "InlineFormContainer-module_container__C0sNt",
  e = {
    container: t
  },
  i = _ref => {
    let {
      children: n
    } = _ref;
    return /* @__PURE__ */o("div", {
      className: e.container,
      children: n
    });
  };
export { i as InlineFormContainer };